import {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";

interface RadioButtonPropsInterface {
	label: string;
	onChange: (item: string) => void;
	mobileVersion?: boolean;
	checked: boolean;
}

interface RadioGroupListPropsInterface {
	title?: string;
	items: string[];
	defaultChecked: string;
	mobileVersion?: boolean;
	onChange: (item: string) => void;
}

function RadioButton(props: RadioButtonPropsInterface) {
	return (
		<div
			className={`select-none relative py-1 pl-8 pr-4 cursor-pointer ${
				props.mobileVersion && "h-14 flex items-center"
			}`}
			onClick={() => {
				props.onChange(props.label);
			}}
		>
      <span className={`block truncate text-leo-button-gray`}>
        {props.label}
      </span>
			<span className={`absolute inset-y-0 left-0 flex items-center`}>
        <input
	        type="radio"
	        name="radio-group"
	        id={props.label}
	        readOnly
	        className="checkbox"
	        checked={props.checked}
        />
      </span>
		</div>
	);
}

export default function RadioGroupList(props: RadioGroupListPropsInterface) {
	const [selectedItem, setSelectedItem] = useState(
		props.defaultChecked ?? props.items[0]
	);
	const {t} = useTranslation();
	useEffect(() => {
		props.onChange(selectedItem);
	}, [selectedItem]);

	return (
		<div className="flex flex-col">
			<span className="input-caption">{props.title}</span>
			<div className={`${props.mobileVersion && "divide-y"}`}>
				{props.items.map((item) => {
					return (
						<RadioButton
							key={item}
							checked={
								selectedItem == item || selectedItem == t(item) ? true : false
							}
							mobileVersion={props.mobileVersion}
							label={t(item)}
							onChange={setSelectedItem}
						/>
					);
				})}
			</div>
		</div>
	);
}
